export default __webpack_public_path__ + "static/media/map.20e76bb4.png";